exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".note-footer[data-v-660129ef]{padding-top:.5rem}.exam-instruction2[data-v-660129ef]{font-size:22px}", "", {"version":3,"sources":["F:/myugfront/src/pages/exam-schedule.vue"],"names":[],"mappings":"AACA,8BACE,iBAAmB,CACpB,AACD,oCACE,cAAgB,CACjB","file":"exam-schedule.vue","sourcesContent":["\n.note-footer[data-v-660129ef]{\n  padding-top: .5rem;\n}\n.exam-instruction2[data-v-660129ef] {\n  font-size: 22px;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-660129ef","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/exam-schedule.vue
// module id = 1006
// module chunks = 19